import { CONSTANTS } from './constants';

export const getWMSRedirectPath = ({
  status,
  asPath,
  query,
  session,
  isUserSubscriber,
  WMS_PROGRAM_CODE,
}: {
  status: string;
  asPath: string;
  query: Record<string, any>;
  session: any;
  isUserSubscriber: (session: any, program: string) => boolean;
  WMS_PROGRAM_CODE: string;
}): string | null => {
  const isWMS = asPath.includes(CONSTANTS.PATH.WMS);
  const isMyLearning = query.view === CONSTANTS.MY_LEARNING;

  if (!isWMS || !isMyLearning) return null;

  if (status === 'unauthenticated') return CONSTANTS.PATH.WMS;
  if (
    status === 'authenticated' &&
    !isUserSubscriber(session, WMS_PROGRAM_CODE)
  ) {
    return CONSTANTS.PATH.WMS;
  }
  return null;
};
